<template>
    <teleport to="body">
        <div class="modal-content">
            <h5 class="modal-title mb-3">Edit Contact</h5>
            <input
                v-model="name"
                placeholder="Name"
                class="contact-field border-radius-lg w-100"
                :disabled="isLoadingEditContact"
            />
            <small v-if="name.trim().length === 0" class="text-danger mx-3">Name is required.</small>
            <input
                v-model="email"
                placeholder="Email"
                class="contact-field border-radius-lg mt-3 w-100"
                disabled
            />
            <div class="d-flex justify-content-end mt-3">
                <button class="btn btn-outline-shareguard me-2" :disabled="isLoadingEditContact" @click="closeEditClicked">Cancel</button>
                <button class="btn btn-shareguard" :disabled="!isFormValid || isLoadingEditContact" @click="editContactClick">
                    {{ isLoadingEditContact ? "Saving..." : "Save Changes" }}
                </button>
            </div>
        </div>
    </teleport>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: 'EditContactModal',
    props: {
        contact: {
            type: Object,
            required: true
        }
    },
    emits: ['close-edit-contact-modal'],
    data() {
        return {
            name: this.contact.name,
            email: this.contact.email
        }
    },
    computed: {
        ...mapGetters("contacts", ["isLoadingEditContact"]),
        isFormValid() {
            const nameValid = this.name.trim().length > 0;
            const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
            return nameValid && emailValid;
        }
    },
    created() {
        this.$store.commit('setOverlay', true);
    },
    beforeUnmount() {
        this.$store.commit('setOverlay', false);
    },
    methods: {
        ...mapActions("contacts", ["updateContactAction"]),
        async editContactClick() {
            if (this.isFormValid) {
                try {
                    await this.updateContactAction({ name: this.name, email: this.email });
                    this.closeEditClicked();
                } catch (error) {
                    console.error("Error updating contact:", error);
                }
            }
        },
        closeEditClicked() {
            this.$emit('close-edit-contact-modal');
        }
    }
}
</script>

<style scoped>
.modal-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 2rem;
    border-radius: 0.5rem;
    width: 100%;
    max-width: 500px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
    z-index: $zindex-modal-content;
}

.contact-field {
    border: 1px solid rgb(229, 231, 235);
    padding: 0.5rem 1rem;
    height: 38px;
}
</style>
